import React, { ReactElement, ReactNode } from 'react';
import { Content } from 'idsk-react-components';
import './layout.scss';

interface Props {
  children: ReactNode;
}

const Layout = ({
  children,
}: Props): ReactElement => (
  <Content className="tezaury-main-container" width="wide">
    {children}
  </Content>
);

export default Layout;
